import React, { useMemo, useState } from 'react';
import { TDirectorInfo } from '../../../types';
import { addIcon, cloud } from '../../../assets/images/dashboard-business';
import Button2 from '../../global/Button2';
import PreviewDocModal from './PreviewDocModal';

type TProps = {
  shareholder: TDirectorInfo;
  setActiveStage: React.Dispatch<React.SetStateAction<number>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  setCurrentShareholder: React.Dispatch<React.SetStateAction<number>>;
  shareholders: TDirectorInfo[];
  currentShareholder: number;
  director?: boolean;
};
const UploadedDocs = ({
  shareholder,
  setActiveStage,
  setStep,
  setCurrentShareholder,
  shareholders,
  currentShareholder,
  director = false,
}: TProps) => {
  const [showModal, setShowModal] = useState(false);
  const [doc, setDoc] = useState('');
  const docs = useMemo(() => {
    return {
      'PASSPORT PHOTOGRAPH': shareholder?.passport,
      'PROOF OF ADDRESS': shareholder?.proofOfAddress,
      'VALID ID CARD': shareholder?.idCard,
      'SIGNATURE SPECIMEN': shareholder?.signature,
    };
  }, [shareholder]);

  const currentShares = shareholders?.reduce(
    (acc, shareholder) => acc + Number(shareholder.share),
    0,
  );

  const completedSteps: boolean[] = JSON.parse(localStorage.getItem('completed-steps') ?? '[]');
  const updateCompletedSteps = () => {
    completedSteps[director ? 4 : 3] = true;
    localStorage.setItem('completed-steps', JSON.stringify(completedSteps));
  };
  return (
    <>
      <div className=' lg:mr-[4vw] h-[100%]'>
        <div className='w-full text-[#657285] text-[16px]'>Uploaded Documents</div>

        <div className='w-full bg-[#CDD8EA] text-[#4F4F4F] font-[500] py-3 px-4 text-sm my-2'>
          DOCUMENT NAME
        </div>

        <table className='w-full'>
          <tbody className='mt-4'>
            {Object.keys(docs)?.map((docName, _) => (
              <tr key={_} className='text-xs border-2 border-[#CDD8EA] py-2 box-content'>
                <td>
                  <div className='sl:flex justify-between flex-wrap py-3 px-3'>
                    <div className='flex gap-2 items-center font-[500] text-[16px] mb-3 text-[#4F4F4F]'>
                      <img src={cloud} alt='' />
                      <div>{docName}</div>
                    </div>

                    <div className='flex gap-2'>
                      <Button2
                        type='submit'
                        theme='tertiary'
                        className='!px-2 !gap-1 md:px-3 py-[10px] text-[11px] inline-block '
                        size='sm'
                        underline={false}
                        onClick={() => {
                          setDoc(docName);
                          setShowModal(true);
                        }}
                      >
                        PREVIEW
                      </Button2>

                      <Button2
                        type='submit'
                        theme='tertiary'
                        className='!px-2 !gap-1 !border-[#DDA000] !text-[#DDA000] md:px-3 py-[10px] text-[11px] inline-block '
                        size='sm'
                        onClick={() => setActiveStage(3)}
                        underline={false}
                      >
                        CHANGE DOCUMENT
                      </Button2>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {!director && (
          <div className='flex justify-between mt-[27px]'>
            {currentShares === 100 && currentShareholder + 1 === shareholders.length && (
              <Button2
                type='submit'
                theme='primary'
                className='!px-2 !gap-1 md:px-3 py-[10px] text-[11px] inline-block '
                size='sm'
                underline={false}
                onClick={() => {
                  setStep((prev) => prev + 1);
                  updateCompletedSteps();
                }}
              >
                CONTINUE
              </Button2>
            )}
            {currentShares < 100 && currentShareholder + 1 === shareholders.length && (
              <Button2
                type='submit'
                theme='tertiary'
                className='!px-2 !gap-1 md:px-3 py-[10px] text-[11px] inline-block '
                size='sm'
                icon={addIcon}
                underline={false}
                onClick={() => {
                  setCurrentShareholder((prev) => prev + 1);
                  setActiveStage(1);
                  updateCompletedSteps();
                }}
              >
                ADD NEW SHAREHOLDER
              </Button2>
            )}

            {currentShareholder + 1 < shareholders.length && (
              <Button2
                type='submit'
                theme='tertiary'
                className='!px-2 !gap-1 md:px-3 py-[10px] text-[11px] inline-block '
                size='sm'
                icon={addIcon}
                underline={false}
                onClick={() => {
                  setCurrentShareholder((prev) => prev + 1);
                  setActiveStage(1);
                  updateCompletedSteps();
                }}
              >
                NEXT SHAREHOLDER
              </Button2>
            )}
          </div>
        )}
        {director && currentShareholder + 1 === shareholders.length && (
          <div className='flex justify-between mt-[27px]'>
            <Button2
              type='submit'
              theme='tertiary'
              className='!px-2 !gap-1 md:px-3 py-[10px] text-[11px] inline-block '
              size='sm'
              icon={addIcon}
              underline={false}
              onClick={() => {
                setCurrentShareholder((prev) => prev + 1);
                setActiveStage(1);
                updateCompletedSteps();
              }}
            >
              ADD NEW DIRECTOR
            </Button2>

            <Button2
              type='submit'
              theme='primary'
              className='!px-2 !gap-1 md:px-3 py-[10px] text-[11px] inline-block '
              size='sm'
              underline={false}
              onClick={() => {
                setStep((prev) => prev + 1);
                updateCompletedSteps();
              }}
            >
              CONTINUE
            </Button2>
          </div>
        )}

        {director && currentShareholder + 1 < shareholders.length && (
          <div className='flex justify-between mt-[27px]'>
            <Button2
              type='submit'
              theme='tertiary'
              className='!px-2 !gap-1 md:px-3 py-[10px] text-[11px] inline-block '
              size='sm'
              icon={addIcon}
              underline={false}
              onClick={() => {
                setCurrentShareholder((prev) => prev + 1);
                setActiveStage(1);
                updateCompletedSteps();
              }}
            >
              NEXT DIRECTOR
            </Button2>
            <Button2
              type='submit'
              theme='primary'
              className='!px-2 !gap-1 md:px-3 py-[10px] text-[11px] inline-block '
              size='sm'
              underline={false}
              onClick={() => {
                setStep((prev) => prev + 1);
                updateCompletedSteps();
              }}
            >
              CONTINUE
            </Button2>
          </div>
        )}
      </div>

      <PreviewDocModal title={doc} obj={docs} setShowModal={setShowModal} showModal={showModal} />
    </>
  );
};

export default UploadedDocs;
